import { render, staticRenderFns } from "./GroupRMCList.vue?vue&type=template&id=76b83218"
import script from "./GroupRMCList.vue?vue&type=script&lang=js"
export * from "./GroupRMCList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports